import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';

import AnchorActivityItem from '../AnchorActivityItem/AnchorActivityItem';

const ModifiedItem = (props) => {
  const { title, filename, oldValue, newValue, isDeleted, onClickFile, activity } = props;
  let actionTypeLabel = title;
  let content = null;

  if (newValue) {
    actionTypeLabel += ` from`;
    content = (
      <React.Fragment>
        <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
          {oldValue}
        </strong>
        <span className={clsx('tw-text-cfo-black')}> to </span>
        {isDeleted ? (
          <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
            {newValue}
          </strong>
        ) : (
          <a
            className={clsx(
              'tw-font-brandonTextBold tw-text-cfo-blue-600 tw-underline',
              'hover:!tw-underline hover:tw-text-cfo-blue-600'
            )}
            aria-hidden="true"
            onClick={onClickFile}
          >
            {newValue}
          </a>
        )}
      </React.Fragment>
    );
  } else {
    actionTypeLabel = (
      <AnchorActivityItem
        actionTypeLabel={` ${_.lowerFirst(activity || title)}`}
        filename={filename}
        onClickFile={onClickFile}
      />
    );
  }

  return (
    <React.Fragment>
      <span> {actionTypeLabel} </span>
      {content}
    </React.Fragment>
  );
};

export default ModifiedItem;
